module.exports = __webpack_public_path__ + "img/empreendimento-logo-14.f785d001.png";